export const CHANGE_CURRENCY = 'core/CHANGE_CURRENCY';
export const CHANGE_LOCALE = 'core/CHANGE_LOCALE';
export const ADD_NOTIFICATION = 'core/ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'core/REMOVE_NOTIFICATION';
export const RECEIVE_DEFAULT_THEME_COLOUR = 'core/RECEIVE_DEFAULT_THEME_COLOUR';
export const COOKIES_DISABLED_ACKNOWLEDGEMENT =
  'core/COOKIES_DISABLED_ACKNOWLEDGEMENT';
